















import { Component, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import IndexMixin from '$utils/mixins/index'

import { prizeTypeCodeList } from '$utils/task-adapter'
import { queryPrizePage, getFreeOrderPrize } from '$services/free-order'

import PrizePop from './_components/prize-pop.vue'

const actModule = namespace('freeOrder')

@Component({
  name: 'float-ball',
  components: {
    PrizePop,
  }
})
export default class RulePop extends IndexMixin {
  @actModule.Getter individualStatistics!: any
  @actModule.Getter actEnd!: boolean
  @actModule.Getter actRuningDayNum!: number

  isShowPrize = false
  animClass = '' // 免单券数量class
  couponList = [] // 免息券列表
  freeLists = [] // 免单大奖信息

  // 开奖描述文案
  get desText() {
    let des
    if (this.actRuningDayNum >= 6) {
      if (this.actEnd) {
        if (this.freeLists && this.freeLists.length > 0) {
          des = '已开奖'
        } else {
          des = '21:03开奖'
        }
      } else {
        des = '21:03开奖'
      }
    } else {
      des = '12.12开奖'
    }
    return des
  }

  @Watch('actEnd')
  async onActEndChange() {
    if (this.actEnd && this.freeLists.length === 0) {
      const freeLists = await getFreeOrderPrize()
      this.freeLists = freeLists
    }
  }

  @Watch('individualStatistics')
  onNumsValue(val: any, oldVal: any) {
    if (val && oldVal && val.prizeCount !== oldVal.prizeCount) {
      this.animClass = 'animing'
      setTimeout(() => {
        this.animClass = ''
      }, 3000)
    }
  }

  // 展示免单券弹窗
  async showPrize() {
    const btnFlag = await this.btnCommonHandle()
    if (!btnFlag) {
      return
    }

    this.$Collect.trackEvent('2020双12火力红包页面_免单_点击')
    this.$Collect.trackView('2020双12免单大奖弹窗_待开奖_浏览')
    const data = await queryPrizePage({
      // 不分页
      filterStatus: 1,
      // 1: 未领取 2: 未激活 3: 未使用 4：冻结 5: 使用中 6: 已使用 7: 已过期 8: 已废弃
      grantStatusList: ['1', '2', '3', '4', '5', '6', '7'],
      // 1:随手记，2：卡牛
      channel: 1,
      // 获取时间倒序
      orderByType: 4,
      // 自定义
      prizeTypeCodeList: [prizeTypeCodeList],
    }).catch((error: any) => {
      console.log('查询免单券列表失败', error)
    })
    this.couponList = data.list
    this.isShowPrize = true
  }
}
